import React, { useState, useCallback } from 'react';
import Filter from '../Components/Filter';
import DataTable from '../Components/Table';
import { Container } from '@mui/material';

const Main = () => {
  const [filters, setFilters] = useState({ status: '', likes: '', nameOrId: '', registrationDate: '' });

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(prevFilters => ({ ...prevFilters, ...newFilters }));
  }, []);

  return (
    <Container>
      <h1>Список пользователей</h1>
      <Filter onFilterChange={handleFilterChange} />
      <DataTable filters={filters} />
    </Container>
  );
};

export default Main;
